import { render, staticRenderFns } from "./date-table.vue?vue&type=template&id=1d06b867"
import script from "./date-table.vue?vue&type=script&lang=js"
export * from "./date-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports